<template>
  <component :is="template"></component>
</template>

<script>
import { STORE_KEY } from './_store/constants'
import store from './_store'
import PrepareDocList from './_views/PrepareDocList'
import PrepareDocDetail from './_views/PrepareDocDetail'
import PrepareDocAdd from './_views/PrepareDocAdd'
import PrepareDocEdit from './_views/PrepareDocEdit'
import ExamAdd from './_views/ExamAdd'
import ExamView from './_views/ExamView'
import ExamList from './_views/ExamList'
import QuestionAnswer from './_views/QuestionAnswer'
import tesst from './_views/tesst'
import Login from './_views/Login'
export default {
  name: 'PrepareDocModule',
  props: {
    template: String
  },
  components: {
      PrepareDocList,
      PrepareDocDetail,
      PrepareDocAdd,
      PrepareDocEdit,
      ExamAdd,
      ExamView,
      ExamList,
      QuestionAnswer,
      Login,
      tesst
  },
  created() {
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>